import React, { PureComponent } from 'react';
import styles from './index.css';

/**
 * 提示：试看结束，弹出 手机客户端的二维码
 */

class PcTipsMask extends PureComponent {

    constructor(props) {
      super(props);

      this.slicePcContent = '';
    }

    render() {

      const { qrImgContent, closureContentText } = this.props;
      const qrImgSrc = 'https:' + qrImgContent;

      this.slicePcContent = closureContentText;

      // 截取移动端展示截流内容的 前16个字
      this.slicePcContent = this.slicePcContent.slice(0, 12);

        return (
            <div className={styles.outerPcMask}>
                <div className={styles.innerPcMask}>
                  <div className={styles.innerContent}>
                    <p className={styles.imgUpText}>{this.slicePcContent }</p> 
                    <img className={styles.img} src={qrImgSrc} alt="手机客户端二维码"/>
                    <p className={styles.imgBottomText}>手机扫描二维码观看</p> 
                  </div>
                </div>
            </div>
        )
    }
}

export default PcTipsMask;
